module.exports = __webpack_public_path__ + "img/18.ebc6d6ce.jpg";